import { JWPlayerConfig } from '@src/modules/players/shared/interfaces/player-configs.interface';
declare const _playerOptions: JWPlayerConfig;
const mobileTapSkip = () => {
  const layerContainer = document.querySelector('.skip-layer-container');

  let tapedTwice = false;

  const tapHandler = (event) => {
    if (jwplayer().getControls() === false) return false;

    if (!tapedTwice) {
      tapedTwice = true;
      setTimeout(function () {
        tapedTwice = false;
      }, 300);
      return false;
    }

    event.preventDefault();

    // action on double tap goes below
    const width = window.innerWidth;
    const clientTouch = event.touches[0].clientX;
    const currentPosition = jwplayer().getPosition();
    const seekStep = _playerOptions.customOption.seekStep || 10;
    if (width / 2 < clientTouch) {
      const newPosition = currentPosition + seekStep;
      jwplayer().seek(newPosition);
      setLayerActive(document.querySelector('.skip-layer.forward'), 'right');
    } else {
      let newPosition = currentPosition - seekStep;
      if (newPosition < 0) newPosition = 0;
      jwplayer().seek(newPosition);
      setLayerActive(document.querySelector('.skip-layer.backward'), 'left');
    }
  };

  let isLayerActive = false;
  const layerTimeout = { left: null, right: null };
  let containerTimeout = null;

  const setLayerActive = (layerElement, side) => {
    if (isLayerActive) {
      clearTimeout(layerTimeout[side]);
      clearTimeout(containerTimeout);
    }
    isLayerActive = true;
    layerElement.classList.add('active');
    layerContainer.classList.add('active');

    layerTimeout[side] = setTimeout(() => {
      layerElement.classList.remove('active');
      containerTimeout = setTimeout(() => {
        layerContainer.classList.remove('active');
        isLayerActive = false;
      }, 500);
    }, 1000);
  };

  document
    .querySelector('.container')
    .addEventListener('touchstart', tapHandler, false);
};

export default mobileTapSkip;
